import React from 'react';
import { Palmtree, Map, Landmark, Mountain } from 'lucide-react';
import { destinations } from '../data/mock';
import { Card, CardContent } from './ui/card';
import WhatsAppCTA from './WhatsAppCTA';

const iconMap = {
  palmtree: Palmtree,
  map: Map,
  landmark: Landmark,
  mountain: Mountain
};

const Destinations = () => {
  return (
    <section id="destinations" className="section-spacing bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="heading-lg text-[#0B1F3A] mb-6 animate-fade-in-up">
            Featured Destinations
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto animate-fade-in-up font-light" style={{ animationDelay: '0.1s' }}>
            Discover handpicked destinations across the globe
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {destinations.map((destination, index) => {
            const IconComponent = iconMap[destination.icon];
            return (
              <Card 
                key={destination.id}
                className="group overflow-hidden border-none shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer animate-fade-in-up bg-white"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="relative h-72 overflow-hidden">
                  <img 
                    src={destination.image}
                    alt={destination.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B1F3A]/90 via-[#0B1F3A]/40 to-transparent"></div>
                  <div className="absolute bottom-6 left-6 right-6">
                    <div className="flex items-center space-x-3 mb-3">
                      <div className="w-10 h-10 bg-[#C8A96A] rounded-full flex items-center justify-center flex-shrink-0">
                        <IconComponent className="text-white" size={20} />
                      </div>
                      <h3 className="text-2xl font-normal text-white">{destination.title}</h3>
                    </div>
                    <p className="text-white/90 text-sm leading-relaxed">
                      {destination.description}
                    </p>
                  </div>
                </div>
                <CardContent className="p-6">
                  <p className="text-[#C8A96A] font-semibold text-base">
                    {destination.priceAnchor}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <WhatsAppCTA message="Hi! I'd like to explore your curated travel experiences." />
      </div>
    </section>
  );
};

export default Destinations;
